import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';



const DeploymentZoneCreator = () => {
  const navigate = useNavigate();

  return (
    <div style={{ width: "100vw", height: "100vh", position: "relative" }}>
      {/* Back button */}
      <button
        onClick={() => navigate("/projects")}
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          zIndex: 1000,
          padding: "4px 6px",
          cursor: "pointer",
          background: "#2a2a2a",
          border: "1px solid #444",
          color: "white",
          fontFamily: "sans-serif",
          fontSize: "16px"
        }}
      >
        Back 
      </button>

      {/* Render your HTML page */}
      <iframe
        src="/games/DeploymentZoneCreator/DeploymentZoneCreator.html"
        title="Deployment Zone Creator"
        style={{
          width: "100%",
          height: "100%",
          border: "none"
        }}
      />
    </div>
  );
};

export default DeploymentZoneCreator;